import { CalendarView } from '../../features/calendar/CalendarView'

/** S6 Calendar (investor). */
export function CalendarPage() {
  return <CalendarView area="app" />
}
